import { route } from "@/lib/utils/route";

export const LINKS = {
  APP_ENTRY: route({ path: "/a" }),
  CUSTOMER_ENTRY_NO_TASKS: route({
    path: "/a/c/accounts/blockchain-addresses",
  }),
  CUSTOMER_ENTRY_W_TASKS: route({ path: "/a/c/get-started" }),
  EDIT_YOUR_INFO_EMAIL: "support@agora.finance",
  // Not published yet; points at the terms PDF until it is.
  ELECTRONIC_COMMUNICATION_AGREEMENT: "https://static.agora.finance/termsofuse.pdf",
  INTERNAL_ADMIN_ENTRY: route({ path: "/a/i/swap-pair-management" }),
  LOGIN: route({ path: "/login" }),
  LOGOUT: route({ path: "/logout" }),
  get MAIL_TO_EDIT_YOUR_INFO_EMAIL() {
    return `mailto:${this.EDIT_YOUR_INFO_EMAIL}`;
  },
  get MAIL_TO_ONBOARDING_SUPPORT_EMAIL() {
    return `mailto:${this.ONBOARDING_SUPPORT_EMAIL}`;
  },
  MARKETING_SITE: "https://agora.finance",
  ONBOARDING: route({ path: "/onboarding" }),
  ONBOARDING_ACCOUNT_USE: route({ path: "/onboarding/account-use" }),
  ONBOARDING_APPLICATION_COMPANY_DOCUMENTS: route({ path: "/onboarding/application/company-documents" }),
  ONBOARDING_APPLICATION_COMPANY_INFO: route({ path: "/onboarding/application/company-info" }),
  ONBOARDING_APPLICATION_FOLLOW_UP_QUESTIONS: route({ path: "/onboarding/application/follow-up-questions" }),
  ONBOARDING_APPLICATION_OWNERSHIP_DETAILS: route({ path: "/onboarding/application/ownership-details" }),
  ONBOARDING_APPLICATION_REVIEW: route({ path: "/onboarding/application/review" }),
  ONBOARDING_APPLICATION_SUBMITTED: route({ path: "/onboarding/application/submitted" }),
  ONBOARDING_COMPANY_BASICS: route({ path: "/onboarding/company-basics" }),
  ONBOARDING_CREATING_PROFILE: route({ path: "/onboarding/creating-profile" }),
  ONBOARDING_FORMATION_DOCUMENT: route({ path: "/onboarding/formation-document" }),
  ONBOARDING_PRIMARY_VOLUME: route({ path: "/onboarding/primary-volume" }),
  ONBOARDING_PRODUCTS: route({ path: "/onboarding/products" }),
  ONBOARDING_REWARDS_RECIPIENTS: route({ path: "/onboarding/rewards-recipients" }),
  ONBOARDING_START: route({ path: "/onboarding/start" }),
  ONBOARDING_SUPPORT_EMAIL: "onboarding@agora.finance",
  ONBOARDING_VERIFICATION: route({ path: "/onboarding/verification" }),
  ONBOARDING_VERIFY_DETAILS: route({ path: "/onboarding/verify/details" }),
  ONBOARDING_VERIFY_DOCUMENTS: route({ path: "/onboarding/verify/documents" }),
  ONBOARDING_VERIFY_RESIDENCE: route({ path: "/onboarding/verify/residence" }),
  ONBOARDING_VERIFY_ROLE: route({ path: "/onboarding/verify/role" }),
  ONBOARDING_VERIFY_START: route({ path: "/onboarding/verify/start" }),
  ONBOARDING_VERIFY_SUBMITTED: route({ path: "/onboarding/verify/submitted" }),
  PRIVACY_POLICY: "https://static.agora.finance/privacypolicy.pdf",
  // Not published yet; points at the terms PDF until it is.
  RISK_DISCLOSURE: "https://static.agora.finance/termsofuse.pdf",
  SOCIAL_LINKEDIN: "https://www.linkedin.com/company/agorafinance",
  SOCIAL_X: "https://x.com/withAUSD",
  TERMS_OF_USE: "https://static.agora.finance/termsofuse.pdf",
};
